import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

export const ReactPortal = ({ children }: { children: JSX.Element }) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);

  // Only render portal on client after mount
  if (typeof document === 'undefined' || !mounted) {
    return null;
  }

  return ReactDOM.createPortal(children, document.body);
};
